import React, { ReactNode } from 'react';
import { Element } from './AccordionBody.styles';
import { Collapse } from '@/components/collapse';
import { useAccordionContext } from '@/components/accordion/context/AccordionContext';
import Transition from 'react-transition-group/Transition';

export interface AccordionBodyProps {
  targetId: string;
  children?: ReactNode;
}

export const AccordionBody = React.forwardRef<Transition<any>, AccordionBodyProps>(function AccordionBody(
  { targetId, children, ...props },
  ref
) {
  const { open } = useAccordionContext();
  return (
    <Collapse ref={ref} {...props} open={Array.isArray(open) ? open.includes(targetId) : open === targetId}>
      <Element>{children}</Element>
    </Collapse>
  );
});

export default AccordionBody;
